<script setup lang="ts">
import { ALERT_STATUS } from "~/common/interfaces/alert-status.enum";
import { useAlertStore } from "~/stores/alert";
import { useColorsStore } from "~/stores/colors";
import { useModalStore } from "~/stores/modal";

const { t } = useI18n();
const route = useRoute();
const alertStore = useAlertStore();
const { colorsConfirmDelete } = useModalStore();
const colorsStore = useColorsStore();

const submitColorDelete = async () => {
	await colorsStore.deleteById(colorsConfirmDelete.color.id);

	colorsConfirmDelete.closeModal();

	if (route.name === "components-colors-color") {
		navigateTo("/components/colors");
	} else if (route.name === "components-colors") {
		colorsStore.getAll({}, colorsStore.recentGetAllQuery);
	}

	alertStore.addAlert({
		title: t("COMPONENTS.COLORS.CONFIRM_DELETE.alert.title"),
		description: t("COMPONENTS.COLORS.CONFIRM_DELETE.alert.description", { colorName: colorsConfirmDelete.color.name }),
		status: ALERT_STATUS.SUCCESS
	});
};
</script>

<template>
	<AppModalConfirm
		:title="$t('COMPONENTS.COLORS.CONFIRM_DELETE.title')"
		:description="$t('COMPONENTS.COLORS.CONFIRM_DELETE.description', {colorName: colorsConfirmDelete.color.name})"
		:close-button-text="$t('COMMON.noCancel')"
		:submit-button-text="$t('COMMON.yesDelete')"
		@close="colorsConfirmDelete.closeModal"
		@submit="submitColorDelete"
	/>
</template>
